'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPersistedThread = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _stubbedThreadId = require('../../threads/constants/stubbedThreadId');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isPersistedThread = exports.isPersistedThread = (0, _pipe2.default)(_threadGetters.getThreadId, function (threadId) {
  switch (threadId) {
    case _stubbedThreadId.STUBBED_THREAD_ID:
      return false;
    default:
      return true;
  }
});